import { DEFAULT_ZOOM_LEVEL } from '../../../shared/constants';
import { Filters, Report, Settings, View } from './overwatch-2-types';

export const initialReport: Report = {
    uuid: 'a-a-a-a-a',
    name: 'Report',
    subscriptionStart: undefined,
    subscriptionEnd: undefined,
};

export const initialFilters: Filters = {
    startDate: null,
    endDate: null,
    setStartDate: () => {},
    setEndDate: () => {},
    useDateInterval: false,
    darkDetectionConfidence: 0,
    setDarkDetectionConfidence: () => {},
    defaultConfidence: 0,
    verifiedActive: false,
    darkActive: false,
    unCorrelatedActive: false,
    windmillsActive: false,
    platformsActive: false,
    setVerifiedActive: () => {},
    setDarkActive: () => {},
    setUnCorrelatedActive: () => {},
    setWindmillsActive: () => {},
    setPlatformsActive: () => {},
    numVerified: 0,
    numDark: 0,
    numUncorrelated: 0,
    numWindmills: 0,
    numPlatforms: 0,
    tags: [],
    setTags: () => {},
    tagFilterStrategy: 'or',
    setTagFilterStrategy: () => {},
    openDate: false,
    setOpenDate: () => {},
    openConfidence: false,
    setOpenConfidence: () => {},
    openDetectionType: false,
    setOpenDetectionType: () => {},
    openStaticObjects: false,
    setOpenStaticObjects: () => {},
    openTags: false,
    setOpenTags: () => {},
    query: '',
    setQuery: () => {},
    openImageSources: false,
    setOpenImageSources: () => {},
    sentinel1Active: false,
    sentinel2Active: false,
    setSentinel1Active: () => {},
    setSentinel2Active: () => {},
};

export const initialSettings: Settings = {
    showProcessingStatus: false,
    setShowProcessingStatus: () => {},
    showSatelliteImage: false,
    setShowSatelliteImage: () => {},
    showEEZ: false,
    setShowEEZ: () => {},
};

export const initialView: View = {
    selected: 0,
    setSelected: () => {},
    selectedView: 'map',
    setSelectedView: () => {},
};

export const initialMapView = {
    latitude: 57.33870347771735,
    longitude: 2.042840975438542,
    zoom: DEFAULT_ZOOM_LEVEL,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, bottom: 0, left: 0, right: 0 },
};
